module.exports = __webpack_public_path__ + "static/media/image (11).486429a2.jpg";